import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const clearRouterFilters = useCallback(() => {
    navigate(
      {
        search: '',
        hash: location?.hash,
      },
      {
        replace: true,
      }
    );
  }, [location?.hash, navigate]);
  /**
   * Removes only the given query-string params, leaving the rest of the URL
   * untouched — e.g. clearing a sentiment filter must not also drop
   * resource_id/resource_name and lose the page's resource scope.
   */
  const clearRouterParams = useCallback(
    (paramNames = []) => {
      const params = new URLSearchParams(location?.search);
      paramNames.forEach((name) => params.delete(name));
      navigate(
        {
          search: params.toString(),
          hash: location?.hash,
        },
        {
          replace: true,
        }
      );
    },
    [location?.hash, location?.search, navigate]
  );
  return { clearRouterFilters, clearRouterParams };
};

export default useRouter;
